type LocaleMap = Record<string, string>

export class I18n {
  readonly locale: string
  readonly locales: LocaleMap

  constructor(jsonFile: LocaleMap, locale: string) {
    this.locale = locale
    this.locales = jsonFile
  }

  t(key: string) {
    const translation = this.locales[key]

    if (translation === undefined) {
      throw new Error("Missing translation!")
    }

    return translation
  }
}

export function parseJSON() {
  try {
    const locales = document.querySelector("#locales")
    return JSON.parse(locales.textContent) || {}
  } catch {
    console.error("Invalid JSON in locale file")
    return {}
  }
}

export function extractLocale() {
  try {
    const localeLanguage = document.querySelector("#locale-language")
    return localeLanguage.textContent
  } catch {
    console.error("Could not find #locale-language node.")
  }
}

